import axios from 'axios'
import params from '@/params/params.js'
import NProgress from 'nprogress'
import store from '@/store/index.js'
import Base64ToFile from '@/Utlidades/Base64ToFile.js'


const apiClient = axios.create({
  baseURL: `${params.path}`,
})

let oConfigBase = {
  headers: {
    'Content-Type'  : 'application/json'
  }
}

let oConfigFile = {
  headers: {
    'Content-Type'  : 'multipart/form-data',
  }
}
NProgress.configure({
  parent: '.v-main',
  showSpinner: false ,
  trickle: true,
  // template: '<div class="cover-page-load"></div><div class="bar bar-primary striped-app" role="bar"></div>'
  template: '<div class="bar bar-primary striped-app" role="bar"></div>'
});

// Se crean interceptore para poner la barra de progreso
apiClient.interceptors.request.use(config => { // Called on request
  NProgress.start()
  return config
})
apiClient.interceptors.response.use(response => { // Called on response
  NProgress.done();
  if(store.state.aDiccionario.length>0){
    let sData = JSON.stringify(response.data)
    store.state.aDiccionario.forEach(item => {
      sData = sData.replaceAll( `??${item.variable}??`, `${store.state.jsIdioma.oEquivalencias[item.variable]}`);
    })
    response.data = JSON.parse(sData)
  }
  return response
},(error)=>{
  NProgress.done()
  switch(error.response.data.nStatusCode){
    case 401: // Cualquier error de Login
      store.dispatch('notificaciones/SetMensaje','Notificación: '+ error.response.data.sMessage );
      store.dispatch('notificaciones/ShowNotificacion',true);    
      store.dispatch('setLogin', false).then(() => {
        window.localStorage.clear()
        sessionStorage.clear()
        let URLdomain = window.location
        window.location.href = `${URLdomain.origin}`
      });
    break
    case 412: // Registro Duplicado
    // console.log('dentro 401')
      store.dispatch('notificaciones/SetMensaje','Notificación: '+ error.response.data.sMessage );
      store.dispatch('notificaciones/ShowNotificacion',true);        
    break
  }
  return error.response
})

export default {
  onValidarsIP(){
    let sIP = store.state.sIP;
    //validamos si se tiene en la url la ip, esto para scriptcas
    let uri = window.location.href.split('?');
    if(uri.length == 2) {
      let aVars = uri[1].split('&');
      let oGetVars = {};
      let tmp = '';
      aVars.forEach(function(v) {
        tmp = v.split('=');
        if(tmp.length == 2)
          oGetVars[tmp[0]] = tmp[1];
      });

      //valido si existe en la url
      if(oGetVars["ip"]!=undefined&&oGetVars["ip"]!=null&&oGetVars["ip"]!=''){
        sIP=oGetVars["ip"];
      }
    }
    else{
      if(store.state.sIP!=null && store.state.sIP!=''){
        sIP=store.state.sIP;
      } else {
        store.state.sIP = sIP
      }
    }

    return sIP;
    
  },
  onValidarsToken(){
    let sToken = store.state.token;
    //validamos si se tiene en la url la ip, esto para scriptcas
    let uri = window.location.href.split('?');
    if(uri.length == 2) {
      let aVars = uri[1].split('&');
      let oGetVars = {};
      let tmp = '';
      aVars.forEach(function(v) {
        tmp = v.split('=');
        if(tmp.length == 2)
          oGetVars[tmp[0]] = tmp[1];
      });

      //valido si existe en la url
      if(oGetVars["t"]!=undefined&&oGetVars["t"]!=null&&oGetVars["t"]!=''){
        sToken=oGetVars["t"];
      }
    }
    else{
      if(store.state.token!=null && store.state.token!=''){
        sToken = store.state.token;
      }
    }

    return sToken;
    
  },
  // Metodos get
  getConfiguration(sURL, bBearer = false, sParams = '' , sTokenTmp = '') {
    //validar si esta nuleada el local store usar la de cache
    let sIP = this.onValidarsIP() || sessionStorage.ip;

    let sParamsExt = store.state.sParamsExt?.replace(/&ip=[^&]*/, "");

    let  sComplementURL = `?origen=WEB&idSubProyecto=${store.state.idSubProyecto}&ip=${sIP}&subdominio=${store.state.sSubDominio}&${sParamsExt}&v=${new Date().getTime()}&sIdioma=${store.state.jsIdioma.sIdiomaPred}`
    
    if(store.state.idCliente != '' && store.state.idCliente != '0'){
      sComplementURL += `&idCliente=${store.state.idCliente}`
    }
    /* 
    Se comenta ya que centro control no implementa filtros por clientes ni por regionales o ciudades
    en la logica de inicio de sesion
    if(store.state.sCiudadesRegional != ''){
      sComplementURL += `&sCiudadesRegional=${store.state.sCiudadesRegional}`
    }
    if(store.state.sFiltroClientes != ''){
      sComplementURL += `&sFiltroClientes=${store.state.sFiltroClientes}`
    }
    */
    if (bBearer) {
      if(sTokenTmp != ''){
        oConfigBase.headers.Authorization = `Bearer ${sTokenTmp}`;
      }else{
        let sToken = this.onValidarsToken();
        oConfigBase.headers.Authorization = `Bearer ${sToken}`;
      }
    }
    if(sParams !== ''){
      sComplementURL+= '&' + sParams
    }
    // Pass parameter openWindow=true in sParams to open in new screen
    if(typeof sParams === 'string' && sParams.indexOf('openWindow=true') !== -1){
      return window.open(`${params.path}${sURL}${sComplementURL}`);
    }
    // Valido el parametro de responseType=blob
    if(typeof sParams === 'string' && sParams.indexOf('responseType=blob') !== -1){
      oConfigBase.responseType = 'blob'
    }
    return apiClient.get(`${sURL}${sComplementURL}` , oConfigBase).then(aGetData => aGetData.data)
  },
  // Metodos POST
  postConfiguration(sURL, oBody, bBearer = false, sParams = '') {
    let sIP = this.onValidarsIP() || sessionStorage.ip;

    let sComplementURL = `?origen=WEB&ip=${sIP}&subdominio=${store.state.sSubDominio}&v=${new Date().getTime()}`;
    if (bBearer) {
      oConfigBase.headers.Authorization = `Bearer ${store.state.token}`;
    }
    if(sParams !== ''){
      sComplementURL+= '&' + sParams
    }
    oBody.nIdUser = store.state.idUser || '0'
    return apiClient.post(`${sURL}${sComplementURL}`, oBody, oConfigBase)
     .then(aResponsePOST => aResponsePOST.data);
  },
  // Metodo PUT
  putConfiguration(sURL, oBody, bBearer = false, sParams = '') {
    let sIP = this.onValidarsIP() || sessionStorage.ip;
    let sComplementURL = `?origen=WEB&ip=${sIP}&subdominio=${store.state.sSubDominio}&${store.state.sParamsExt}&v=${new Date().getTime()}`;
    if (bBearer) {
      oConfigBase.headers.Authorization = `Bearer ${store.state.token}`;
    }
    if(sParams !== ''){
      sComplementURL+= '&' + sParams
    }
    oBody.nIdUser = store.state.idUser
    return apiClient.put(`${sURL}${sComplementURL}`, oBody, oConfigBase)
     .then(aResponsePUT => aResponsePUT.data);
  },
  // Metodo para post file debe surbir un FormData()
  //   let formData = new FormData()
  //   formData.append('file', file)  -> file es la fila como tal
  // Tipo Anexo 1 Foto 2 DOc
  postFile(sURL, FormData, bBearer = false,nTipoAnexo =1) {
    let sIP = this.onValidarsIP() || sessionStorage.ip;
    let sComplementURL = `?nTipoAnexo=${nTipoAnexo}&origen=WEB&ip=${sIP}&subdominio=${store.state.sSubDominio}&${store.state.sParamsExt}&v=${new Date().getTime()}`;

    if (bBearer) {
      oConfigFile.headers.Authorization = `Bearer ${store.state.token}`;
    }
    
    return apiClient.post(`${sURL}${sComplementURL}`, FormData, oConfigFile)
    .then(aResponsePOST => {
      try {
       return aResponsePOST.data
      } catch (error) {
        return []
      }
    }) 
  },
  deleteConfiguration(sURL, oBody, bBearer = false, sParams = '') {
    let sIP = this.onValidarsIP() || sessionStorage.ip;
    if(store.state.sIP!=null && store.state.sIP!=''){
      sIP=store.state.sIP;
    }
    let sComplementURL = `?origen=WEB&ip=${sIP}&subdominio=${store.state.sSubDominio}&${store.state.sParamsExt}&v=${new Date().getTime()}&sIdioma=${store.state.jsIdioma.sIdiomaPred}`;
    if(store.state.idCliente != '' && store.state.idCliente != '0'){
      sComplementURL += `&idCliente=${store.state.idCliente}`
    }
    if (bBearer) {
      oConfigBase.headers.Authorization = `Bearer ${store.state.token}`;
    }
    if(sParams !== ''){
      sComplementURL+= '&' + sParams
    }
    oBody.nIdUser = store.state.idUser
    if (Object.keys(oBody).length > 0) {
      oConfigBase.data = oBody
    }
    return apiClient.delete(`${sURL}${sComplementURL}`, oConfigBase)
     .then(aResponsePUT => aResponsePUT.data);
  },
  // Metodo para enviar fotos como files recibiendo com base 64
  async postFoto(sNombreArchivo, sBase64){
    const file = await Base64ToFile.Base64toFile(sBase64, sNombreArchivo,'image/png')

    let formData = new FormData()

    formData.append('file', file)

    return this.postFile('/subirarchivo', formData, true)

  },
}
